/**
 * O que faz: Modal de detalhe de métrica com fórmula em uma frase e lista do numerador.
 * Onde usa: Dashboard e seções analíticas ao clicar em “Ver detalhes”.
 * Conexões: DialogContent compartilhado (fade + scale), detalheMetricas e apresentacaoMetricas.
 * Tabelas: Nenhuma direta; itens vêm de RPC de detalhe por props.
 * Data: 05/09/2026.
 */

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { apresentarIndicador } from '@/features/metricas/apresentacaoMetricas';
import type { IndicadorMetrica } from '../../../supabase/functions/_shared/metricas/contratos';

interface MetricasDetalheDialogProps {
  aberto: boolean;
  aoFechar: () => void;
  titulo: string;
  formula: string;
  indicador: IndicadorMetrica;
  itens: Array<{ id: string; nome: string }>;
  total: number;
  aoAlternarDenominador?: () => void;
  mostrandoDenominador?: boolean;
}

export function MetricasDetalheDialog({ aberto, aoFechar, titulo, formula, indicador, itens, total, aoAlternarDenominador, mostrandoDenominador }: MetricasDetalheDialogProps) {
  // Modal fechado não monta queries nem importa o chat; foco e Escape preservados pelo base.
  const apresentado = apresentarIndicador(indicador);
  return (
    <Dialog open={aberto} onOpenChange={(novo) => { if (!novo) aoFechar(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">{formula}</p>
        <p className="mt-1 text-sm tabular-nums">
          {apresentado.valor}{apresentado.base ? ` · ${apresentado.base}` : ''} · {total} no total
        </p>
        {aoAlternarDenominador && (
          <button type="button" onClick={aoAlternarDenominador} className="mt-2 text-sm font-medium text-accent-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">
            {mostrandoDenominador ? 'Ver apenas o numerador' : 'Ver o denominador'}
          </button>
        )}
        <ul className="mt-3 max-h-64 overflow-auto">
          {itens.map((item) => (
            <li key={item.id} className="border-t border-border py-2 text-sm">{item.nome}</li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
